import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Captcha from "../components/Captcha";
import API_BASE_URL from "../config";
function SignupPage() {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    password: "",
    confirmPassword: "",
    captcha: "",
  });

  const [captchaValue, setCaptchaValue] = useState(""); // Captcha value generated
  const [captchaInput, setCaptchaInput] = useState(""); // User input for captcha
  const [captchaError, setCaptchaError] = useState(""); // Error message for captcha
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const refreshCaptcha = () => {
    setCaptchaValue(""); // Clear previous captcha value
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (formData.password !== formData.confirmPassword) {
      return setError("Passwords don't match.");
    }

    if (captchaInput !== captchaValue) {
      setCaptchaError("Captcha does not match.");
      return;
    }

    try {
      const res = await axios.post(
        `${API_BASE_URL}/register`,
        { ...formData, captcha: captchaInput },
        { withCredentials: true }
      );
      if (res.data.success) {
        setSuccess(
          "Registration successful. Please check your email to verify."
        );
        setTimeout(() => navigate("/verify-email"), 2000);
      } else {
        setError(res.data.message || "Signup failed.");
      }
    } catch (err) {
      setError("Registration failed. Please check the form and captcha.");
    }
  };

  return (
    <div className="container mt-5">
      <div className="row">
        <div className="col-md-5 col-12">
          <div className="inbx formbxx">
            <div className="frmtbx">
              <h2 className="mb-2 text-center fw700">
                <i class="bi bi-person-plus me-1"></i> Register
              </h2>
              <p className="mb-4 text-center  pb-3">
                Create your account to take your business to new heights. It's free and
                fast!
              </p>
            </div>
            {error && <div className="alert alert-danger">{error}</div>}
            {success && <div className="alert alert-success">{success}</div>}
            <form onSubmit={handleSubmit}>
              <div className="mb-3">
                <label>Name</label>
                <input
                  type="text"
                  className="form-control"
                  name="name"
                  required
                  value={formData.name}
                  onChange={handleChange}
                />
              </div>

              <div className="mb-3">
                <label>Email</label>
                <input
                  type="email"
                  className="form-control"
                  name="email"
                  required
                  value={formData.email}
                  onChange={handleChange}
                />
              </div>

              <div className="mb-3">
                <label>Password</label>
                <input
                  type="password"
                  className="form-control"
                  name="password"
                  required
                  value={formData.password}
                  onChange={handleChange}
                />
              </div>

              <div className="mb-3">
                <label>Confirm Password</label>
                <input
                  type="password"
                  className="form-control"
                  name="confirmPassword"
                  required
                  value={formData.confirmPassword}
                  onChange={handleChange}
                />
              </div>
              <div className="row">
                <div className="col-md-5">
                  <Captcha onChange={(val) => setCaptchaValue(val)} />{" "}
                  {/* Captcha component */}
                </div>
                <div className="col-md-7">
                  <div className="mb-3">
                    <input
                      type="text"
                      className="form-control"
                      name="captcha"
                      placeholder="Enter Captcha"
                      required
                      value={captchaInput}
                      onChange={(e) => setCaptchaInput(e.target.value)}
                    />
                  </div>
                </div>
              </div>
              {captchaError && (
                <div className="alert alert-danger">{captchaError}</div>
              )}

              <button type="submit" className="btn btn-success w-100">
                Register
              </button>

              <div className="mt-3 text-center">
                <a className="color1 text-decoration-none" href="/login">
                  Already have an account?{" "}
                  <span className="text-success">Login</span>
                </a>
              </div>
            </form>
          </div>
        </div>
        <div className="col-md-7 col-12 gx-0 limgcn">
          <img src="/reg-bg.png" alt="Logo" className="login-bg" />
        </div>
      </div>
    </div>
  );
}

export default SignupPage;
